module.exports = __webpack_public_path__ + "static/img/9.02ae9fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/9.jpg
// module id = O5T+
// module chunks = 1